devex = devex || {};

/**
 * Funding namespace.
 *
 * Contains general utilities for funding
 */
devex.funding = devex.funding || {};

devex.funding.titleDisplay = function (title) {
  switch (title) {
    case 'pipeline': return 'program';
    case 'Pipeline': return 'Program';
    case 'funding_info': return 'Funding Activity';
    case 'contract': return 'Contract Award';
    default: return title;
  }
};

/**
 * Extract report value from report coming details funding projects endpoint
 *
 * @param {Object} report - Report coming details funding projects endpoint
 * @param {string} [report.value_display] - Report value already formatted and humanized by BE
 * @param {Integer} [report.value] - Report value as integer, that needs to be humanized
 *
 * @returns {string | null} Humanized report value, ready to be shown
 */
devex.funding.displayReportValue = function (report) {
  if(report.value_display) {
    return report.value_display;
  } else if (report.value) {
    return devex.util.numberToHuman(report.value);
  }
  return null;
};

devex.funding.affixElements = function () {
  var $actionBar = $('.action-bar');

  if ($actionBar.length) {
    $actionBar.affix({offset: {top: $actionBar.offset().top} });
  }
};

devex.funding.resultListHeight = function () {
  var paginationHeight = $('.pagination-container').outerHeight();
  var resultsHeaderHeight = $('.results-header-container').height();
  if (resultsHeaderHeight > 150) {
    resultsHeaderHeight = 150;
  }
  if ((navigator.userAgent.indexOf('Safari') == -1 ||
       navigator.userAgent.indexOf('Chrome') != -1) &&
       !devex.util.isMobile()) {

    $('.search-results-container')
      .css({
        'height': $(window).height() - paginationHeight - resultsHeaderHeight
      });
  }
};

devex.funding.resultListPosition = function () {

  if ((navigator.userAgent.indexOf('Safari') == -1 ||
       navigator.userAgent.indexOf('Chrome') != -1) &&
       !devex.util.isMobile()) {

    var top = Math.min(
      Math.max($(window).scrollTop() - $('.result-detail').offset().top, 0),
      Math.max($('.result-detail').height() - $('.result-list').height(), 0)
    );
    $('.result-list').css({'marginTop': top + 'px'});
  }
};
